import { render, staticRenderFns } from "./precalificacionesCompletadas.vue?vue&type=template&id=853f0eb6&scoped=true"
import script from "./precalificacionesCompletadas.vue?vue&type=script&lang=js"
export * from "./precalificacionesCompletadas.vue?vue&type=script&lang=js"
import style0 from "./precalificacionesCompletadas.vue?vue&type=style&index=0&id=853f0eb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853f0eb6",
  null
  
)

export default component.exports